module.exports = __webpack_public_path__ + "static/media/TUNE_6221.217a73fe.jpg";